module.exports = __webpack_public_path__ + "img/020-expand.06de9760.svg";